import React from 'react'
import { TablaMiFormularioAgentes } from '../../Components/Components'

export const MiFormularioAgentes = ({initState,updateState,data,setData,updateStatusFichaAgente}) => {
  console.log(data);
  return (
    <React.Fragment>
      <TablaMiFormularioAgentes 
      initState={initState} 
      updateState={updateState} 
      data={data} 
      setData={setData}
      updateStatusFichaAgente={updateStatusFichaAgente}
      />
    </React.Fragment>
  )
}